module.exports = __webpack_public_path__ + "bin/48278bd801e6e21cf7672cd7e4755a52.jpg";